import { isNil } from 'ramda';

export default function logError(error, message) {
  const text = isNil(message) ? error : `${message}\n${error}`;
  console.error(text);
}
